export default "<p>logs works!</p>\n"